import { Data } from '../reduxTypes';

const cleanState = {
  overviewData: null,
  dateFilterRangeLimit: null,
  selectedCurrency: null,
  defaultCurrency: null,
  glanceMarkets: null,
  glanceDefaults: null,
  currencies: null,
  messagingInfo: null,
  metaData: null,
  environment: null,
  newMsgsCount: 0,
  intervalId: null
};

const initialState: Data = {
  ...cleanState
};

interface ReduxProps {
  type: string;
  value: any;
}

export default (state = initialState, { type, value }: ReduxProps): any => {
  switch (type) {
    case 'SET_OVERVIEW_DATA':
      return {
        ...state,
        overviewData: value
      };
    case 'SET_DATE_RANGE_LIMIT':
      return {
        ...state,
        dateFilterRangeLimit: value
      };
    case 'SET_SELECTED_CURRENCY':
      return {
        ...state,
        selectedCurrency: value
      };
    case 'SET_DEFAULT_CURRENCY':
      return {
        ...state,
        defaultCurrency: value
      };
    case 'SET_GLANCE_MARKETS':
      return {
        ...state,
        glanceMarkets: value
      };
    case 'SET_GLANCE_DEFAULTS':
      return {
        ...state,
        glanceDefaults: value
      };
    case 'SET_CURRENCIES':
      return {
        ...state,
        currencies: value
      };
    case 'SET_ENVIRONMENT':
      return {
        ...state,
        environment: value
      };
    case 'SET_MESSAGING':
      return {
        ...state,
        messagingInfo: value
      };
    case 'SET_META_DATA':
      return {
        ...state,
        metaData: value
      };
    case 'SET_UNREAD_NOTES':
      return {
        ...state,
        newMsgsCount: value
      };
    case 'SET_INTERVAL_ID':
      return {
        ...state,
        intervalId: value
      };
    default:
      return state;
  }
};
